import { ButtonGroup, Dropdown, DropdownButton } from "react-bootstrap";
import React from "react";
import { paths } from "../../router";
import { OrderCategory, TApiOrder } from "../../api/endpoints/Order";
import { useHistory } from "react-router-dom";

const AddOrderButton = () => {
  const history = useHistory();

  const ORDER_ADD_PATH_MAPPING = {
    archive: paths.archiveOrderNew,
    web: paths.webOrderNew,
    realtime: paths.realtimeOrderNew
  }

  const onOrderAdd = (category: Exclude<TApiOrder['category'], OrderCategory.EU_CUTOUT>) => () => {
    history.push(ORDER_ADD_PATH_MAPPING[category]);
  }

  return (
    <DropdownButton as={ButtonGroup} title="Add order" id="order-add">
      <Dropdown.Item eventKey="1" onClick={onOrderAdd(OrderCategory.REALTIME)}>Realtime</Dropdown.Item>
      <Dropdown.Item eventKey="2" onClick={onOrderAdd(OrderCategory.ARCHIVE)}>Archive</Dropdown.Item>
      <Dropdown.Item eventKey="3" onClick={onOrderAdd(OrderCategory.WEB)}>Web</Dropdown.Item>
    </DropdownButton>
  )
}

export default AddOrderButton;
